import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextarea,_vm._g(_vm._b({attrs:{"label":_vm.label,"placeholder":_vm.placeholder,"filled":"","rules":_vm.allRules},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'v-textarea',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }